import React, { memo, useState } from "react";
import { FieldArray, FormikProps, useFormikContext } from "formik";
import { Bin, Data } from "../../../store/processor/types";
import {
  Grid,
  Box,
  Button,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
} from "@mui/material";
import pageStyles from "../../pageStyles";
import SectionWrapper from "../../../common/pageSections/SectionWrapper";
import { Add, Delete, ExpandMore, Payment } from "@mui/icons-material";
import ProcessorBinForm from "./ProcessorBinForm";
import Confirm from "../../../common/confirm/Confirm";

const ProcessorBin = () => {
  const formikProps = useFormikContext();
  const { values } = formikProps as FormikProps<Data>;

  const styles = pageStyles();
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(0);

  const binObj: Bin = {
    Account: [],
    From: "",
    To: "",
    Length: 0,
    AmountFrom: 0,
    AmountTo: 0,
  };

  return (
    <SectionWrapper title="BIN" isChild isWhiteBG>
      <FieldArray
        name="attributes.Bin"
        render={(arrayHelpers) => {
          return (
            <>
              {values.attributes?.Bin?.map((bin: Bin, index) => {
                return (
                  <Accordion key={index} className={styles.Accordion}>
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls={`${index}_content`}
                      id={`${index}_header`}
                    >
                      <Box className={styles.processorTitleWrapper}>
                        <Typography className={styles.processorTitle}>
                          <Payment style={{ marginRight: "5px" }} />
                          {`Bin ${index + 1}`}
                        </Typography>
                        <Button
                          color="secondary"
                          variant="outlined"
                          onClick={() => {
                            setDeleteItemId(index);
                            setShowConfirm(true);
                          }}
                          size="small"
                          startIcon={<Delete />}
                        >
                          Delete
                        </Button>
                      </Box>

                      <Confirm
                        isOpen={showConfirm}
                        onCancel={() => setShowConfirm(false)}
                        onConfirm={() => {
                          arrayHelpers.remove(deleteItemId);
                          setShowConfirm(false);
                        }}
                        title="Delete Bin"
                        icon="danger"
                        confirmLabel="Delete"
                        contentText={`You are about to delete a Bin`}
                      />
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        background: "#fff",
                        borderTop: "1px solid #efefef",
                      }}
                    >
                      <Grid container style={{ marginTop: "15px" }}>
                        <Grid item xs={12}>
                          <ProcessorBinForm index={index} bin={bin} />
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                );
              })}

              <Grid item xs={12}>
                <Box textAlign="center">
                  <Button
                    color="primary"
                    variant="contained"
                    size="medium"
                    endIcon={<Add />}
                    onClick={() => arrayHelpers.push(binObj)}
                    style={{ marginTop: "15px" }}
                  >
                    Create Bin
                  </Button>
                </Box>
              </Grid>
            </>
          );
        }}
      />
    </SectionWrapper>
  );
};

export default memo(ProcessorBin);
